module.exports = __webpack_public_path__ + "static/media/skinTexture.06eb0b47.jpg";